<template>
  <div class="l-d-consult-info">
    <p class="consult-time">週一到週五 8:00 -17:00</p>

    <div class="consult-phone">
      <p class="consult-phone__text">免費服務專線 | 0800-00-3595 (生我救我)</p>
      <p class="consult-phone__text">行政諮詢專線 | (02)2511-1608</p>
      <p class="consult-phone__text">衛教諮詢專線 | (02)2523-0908</p>
      <p class="consult-phone__text">追蹤檢查專線 | (02)2522-1792</p>
      <p class="consult-phone__text">官方電子信箱 | <a class="consult-phone__text__email" href="mailto:pbf@pbf.org.tw">pbf@pbf.org.tw</a></p>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ConsultInfo',
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';

.consult-time {
  margin-top: 28px;

  @include font-style($c-white, $f-footer, 500, 1.4px, 26px);
}

.consult-phone {
  margin-top: 8px;
  padding-bottom: 30px;

  &__text {
    @include font-style($c-white, $f-footer, 500, 1.4px, 26px);

    &__email {
      text-decoration: none;
      color: $c-white;
    }
  }
}

@media screen and (min-width: $tablet) {
  .consult-time {
    margin-top: 40px;
  }

  .consult-phone {
    padding-bottom: 0;
  }
}
</style>
